import React, { useCallback } from "react";
import { permissions } from "components/auth";
import { useAuthDataContext } from "components/auth";
import DataGrid, { DataGridItem } from "components/data-grid";
import Typography from "@material-ui/core/Typography";
import { FormattedMessage, injectIntl } from "react-intl";
import styles from "./styles/customer-selection.css.js";
import withStyles from "components/with-styles";
import { useCurrentCustomerContext } from "../../../components/current-customer-context";
import { useImperativeTracking } from "../../../components/tracking";
import CustomerSelect from "../../../components/select/customer-select";

const CustomerSelection = ({ classes, intl, multiple = true }) => {
  const { user } = useAuthDataContext();
  const { currentCustomerId, setCurrentCustomerId } = useCurrentCustomerContext();
  const track = useImperativeTracking();

  const handleChange = useCallback(
    ({ target: { value } }) => {
      track("changes current customer from " + currentCustomerId + " to " + value);
      setCurrentCustomerId(value);
    },
    [currentCustomerId, setCurrentCustomerId, track],
  );

  return user && user.permissions.includes(permissions.scoped_by_customer_view) ? null : (
    <DataGrid className={classes.container}>
      <DataGridItem>
        <Typography className={classes.titleContainer} component="h5">
          <FormattedMessage id="app.customer.scoped.assets.label">
            {(...content) => <span className={classes.title}>{content}</span>}
          </FormattedMessage>
        </Typography>
      </DataGridItem>
      <DataGridItem className={classes.selectorContainer}>
        <CustomerSelect
          multiple={multiple}
          label={intl.formatMessage({ id: "app.customer" })}
          id="currentCustomerId"
          handleChange={handleChange}
          value={currentCustomerId}
        />
      </DataGridItem>
    </DataGrid>
  );
};

export default injectIntl(withStyles(styles)(CustomerSelection));
